module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Summary")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedCOGS.length))])]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(item && index === 'SGD') ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
          }, [_vm._v("Total Amount in " + _vm._s(index) + ": "), _c('span', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))])]) : _vm._e(), _vm._v(" "), (item && index !== 'SGD') ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
          }, [_vm._v("Inclusive (" + _vm._s(index) + "): "), _c('span', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))])]) : _vm._e()])
        })], 2)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61992534"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CogsEstimate/TotalSummaryModal.vue
// module id = 2155
// module chunks = 0